import React from 'react';
import './JellyFish.css';

const JellyFish = ({ style }) => {
  return (
    <div className="jellyfish" style={style}>
      <div className="tentacle"></div>
      <div className="tentacle"></div>
      <div className="tentacle"></div>
      <div className="tentacle"></div>
    </div>
  );
};

export default JellyFish;